export type {
  CardFooterSlots,
  CardFooterBaseProps as CardFooterProps,
  CardFooterBaseState as CardFooterState,
} from '@fluentui/react-card';
